import * as yup from 'yup'
import { BootFileParams } from '@niknevis/vue-modules/types'
import { Str } from '@/modules/shared/helpers/facades/string'

export const MESSAGES = {
  REQUIRED: 'این فیلد اجباری است',
  VALID: 'ورودی صحیح نمیباشد',
  NUMBER: 'لطفا فقط عدد وارد نمایید.',
  MIN: 'عدد باید بزرگتر از ${min} باشد',
  MAX: 'عدد باید کوچکتر از ${max} باشد',
  STRING: 'فرمت وارد شده صحیح نیست.',
  MINLENGTH: 'تعداد کاراکتر کمتر از حد مجاز {minLength}',
  MINLENGTH_NUMBER: 'عدد باید بزرگتر یا مساوی  {minLength} باشد',
  MAXLENGTH: 'تعداد کاراکتر بیشتر از حد مجاز {maxLength}',
  MAXLENGTH_NUMBER: 'عدد باید کوچکتر یا مساوی {maxLength} باشد',
  FILE_TYPE: 'فرمت فایل نامعتبر.',
  FILE_EXTENSIONS: 'فرمت فایل نامعتبر. فرمت های معتبر: {extensions}',
  EMAIL: 'ایمیل صحیح نیست',
  PHONENUMBER: 'شماره موبایل صحیح نیست',
  PERSIAN: 'فقط از حروف فارسی استفاده کنید',
  DATE: 'فرمت تاریخ وارد شده صحیح نیست',
  ARRAYMIN: 'حداقل {0} مورد در این فیلد قرار دهید'
}

export default function(ctx: BootFileParams) {
  yup.setLocale({
    mixed: {
      required: MESSAGES.REQUIRED,
      notType: MESSAGES.VALID
    },
    number: {
      min: MESSAGES.MIN,
      max: MESSAGES.MAX
    },
    array: {
      min: (ctx) => {
        return Str.format(MESSAGES.ARRAYMIN, [ctx.min])
      }
    },
    string: {
      email: () => {
        return MESSAGES.EMAIL
      }
    }
  })
}
